import React, { useCallback } from "react";
import {
  FormControlLabel,
  Grid,
  makeStyles,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  TextField,
} from "@material-ui/core";
import ReportsCard from "./ReportsCard";
import { map } from "ramda";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: 10,
  },

  cardForm: {
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 20,
  },

  datePicker: {
    minWidth: 130,
    width: "100%",
  },
}));

const OrganizationSelectionCard = ({
  reportType,
  state,
  handleStateChange,
  organizations,
}) => {
  const classes = useStyles();

  const handleSelectedOrganization = useCallback(
    value => {
      console.log(value);
      handleStateChange("selectedOrganization")(value);
    },
    [handleStateChange]
  );

  return (
    <ReportsCard
      classes={{ root: classes.root }}
      cardLabel={`Enter your email address below, and click "Export" in the bottom right corner under the module list. Once generated, a link to your ${reportType} will be emailed to the address provided`}
    >
      <Grid
        container
        spacing={2}
        direction="column"
        classes={{ root: classes.cardForm }}
      >
        <Grid item>
          <FormControl fullWidth>
            <InputLabel id="organization-select-label">
              Select Organization
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              value={state.selectedOrganization}
              onChange={e => handleSelectedOrganization(e.target.value)}
            >
              {map(
                ({ id, name }) => (
                  <MenuItem key={id} value={id}>
                    <Typography nowrap="true">
                      {name}
                      <br />({id})
                    </Typography>
                  </MenuItem>
                ),
                organizations
              )}
            </Select>
          </FormControl>
        </Grid>

        {reportType === "MARC" && (
          <Grid item>
            <FormControlLabel
              control={
                <Checkbox
                  checked={state.useCustomSubdomain}
                  onChange={e =>
                    handleStateChange("useCustomSubdomain")(e.target.checked)
                  }
                  name="useCustomSubdomain"
                />
              }
              label="Include alias in 856 link"
            />
          </Grid>
        )}
        <Grid item>
          <TextField
            label="Email Address"
            fullWidth
            value={state.emailAddress}
            onChange={e => handleStateChange("emailAddress")(e.target.value)}
          />
        </Grid>
      </Grid>
    </ReportsCard>
  );
};

export default OrganizationSelectionCard;
